// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f596070b","453":"70723d0f","455":"13b35924"}[chunkId] + ".chunk.js";
};